<script setup lang="ts">
import { useGlobalLoadingScreen } from "@/stores/globalLoadingScreenStore";
import { LuvProgressFullscreen } from "@polargold/luv-ui-library";

const globalLoading = useGlobalLoadingScreen();
</script>/

<template>
    <LuvProgressFullscreen v-if="globalLoading.isLoading" class="animate-fade"/>
</template>
